import React from 'react'
import AssessmentTable from './AssessmentTable'

function UpcomingMarking({globalReset,filterIntake,filterLearningMethod,filterSchool,filterLecturer}) {
  return <AssessmentTable globalReset={globalReset} filterIntake={filterIntake} filterLearningMethod={filterLearningMethod} filterLecturer={filterLecturer} filterSchool={filterSchool}/>
}

export default UpcomingMarking